<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['supplyOrganizationCode']"
          :allow-clear="false"
          :default-active-first-option="true"
          slot="supplyOrganizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.supplyOrganizationCode"
          :selectData="organizationList"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          slot="organizationCodeList"
          :value.sync="queryParams.organizationCodeList"
          selectType="selectAssembleMultiple"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :selectData="organizationList"
          :assembleLabel="true"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.statusList"
          :selectData="statusList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="orderType"
          :dropdown-match-select-width="false"
          v-model="queryParams.orderType"
          selectType="selectMultiple"
          requestApi="/inv/invOnhandQuantities/findOrderTypeList"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          sourseField="res"
        />
        <a-switch slot="deliveredButNotReceivedFlag" default-checked v-model="queryParams.deliveredButNotReceivedFlag" />
        <a-switch slot="toBeDeliveredFlag" default-checked v-model="queryParams.toBeDeliveredFlag" />
        <a-switch slot="returnedFlag" default-checked v-model="queryParams.returnedFlag" />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvExportComponentCallList" ref="download" />
        <a-button
          type="primary"
          @click="handleExport"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import {
  apiGetComponentCallList,
  apiInvExportComponentCallList
} from '@/api/report/inventory-outbound-details'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import { apiTSysInventoryOrganizationList } from '@/api/mdm/supplychain/inventoryOrganization'

export default {
  // eslint-disable-next-line
  name: 'Component-handover', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  data() {
    return {
      statusList: [], // 状态
      apiInvExportComponentCallList,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetComponentCallList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        returnedFlag: false,
        toBeDeliveredFlag: false,
        deliveredButNotReceivedFlag: false,
        supplyWipEntityName: undefined,
        orderNo: undefined,
        orderType: undefined,
        callDocNumber: undefined,
        workCode: undefined,
        itemCode: undefined,
        demandDate: undefined,
        startDemandDate: undefined,
        endDemandDate: undefined
      },
      organizationList: [], // 需求组织数据
      // 表格数据
      tableList: [],
      formList: [
        { label: '供应组织', decorator: ['supplyOrganizationCode'], type: 'supplyOrganizationCode' },
        { label: '需求组织', decorator: ['organizationCodeList'], type: 'organizationCodeList' },
        { label: '计划单号', decorator: ['orderNo'], type: 'input' },
        { label: '供应工单', decorator: ['supplyWipEntityName'], type: 'input' },
        // { label: '所属车间code', decorator: ['workCode'], type: 'input' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        { label: '物料名称', decorator: ['itemName'], type: 'input' },
        { label: '状态', decorator: ['statusList'], type: 'statusList' },
        {
          label: '要求送货日期',
          type: 'range',
          decorator: ['demandDate'],
          disposeFormat: {
            startDemandDate: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endDemandDate: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '已送货未接收', decorator: ['deliveredButNotReceivedFlag'], type: 'deliveredButNotReceivedFlag' },
        { label: '待送货', decorator: ['toBeDeliveredFlag'], type: 'toBeDeliveredFlag' },
        { label: '已退货', decorator: ['returnedFlag'], type: 'returnedFlag' }
      ],
      // 表格字段
      columns: [
        { title: '需求组织', dataIndex: 'organizationName', align: 'center', width: 180, ellipsis: true },
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 150, ellipsis: true },
        { title: '供应组织', dataIndex: 'supplyOrganizationName', align: 'center', width: 180, ellipsis: true },
        { title: '叫料单号', dataIndex: 'callDocNumber', align: 'center', width: 140, ellipsis: true },
        // { title: '所属车间code', dataIndex: 'workCode', align: 'center', width: 150, ellipsis: true },
        // { title: '所属车间', dataIndex: 'workshopDesc', align: 'center', width: 150, ellipsis: true },
        { title: '叫料单状态', dataIndex: 'statusName', align: 'center', width: 120 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 160, ellipsis: true },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 180, ellipsis: true },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 180, ellipsis: true },
        { title: '供应工单', dataIndex: 'supplyWipEntityName', align: 'center', width: 160, ellipsis: true },
        { title: '要求送货日期', dataIndex: 'demandDate', align: 'center', width: 150, ellipsis: true },
        { title: '要求送货数量', dataIndex: 'demandQty', align: 'center', width: 120, ellipsis: true },
        { title: '已送货数量', dataIndex: 'shipmentQuantity', align: 'center', width: 120, ellipsis: true },
        { title: '组装中心已接收数量', dataIndex: 'receivedQuantity', align: 'center', width: 160 },
        { title: '组装中心已退货数量', dataIndex: 'returnedQuantity', align: 'center', width: 160 },
        { title: '当前库存现有量', dataIndex: 'onhandQuantity', align: 'center', width: 150, ellipsis: true }
      ]
    }
  },
  created() {
    this.getLookupList('INV_CALL_DOC_STATUS', 'statusList')
    this.getOrganization(); // 查询全部组织
  },
  mounted() {
    // this.onSearch()
  },
  methods: {
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "INV_CALL_DOC_STATUS") {
          const arr2 = []
          response.rows.forEach(element => {
            arr2.push(element)
          });
          this[arr] = arr2
          return
        }
        this[arr] = response.rows
      })
    },
    // 查询全部组织
    getOrganization() {
      this.organizationList = []
      apiTSysInventoryOrganizationList({ pageSize: 1000, pageNum: 1 }).then(res => {
        if (res?.rows?.length > 0) {
          this.organizationList = res.rows.map(e => { return { 'realValue': e?.organizationNo, 'label': e?.organizationName } });
        }
        this.onSearch()
      })
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      const searchObj = cloneDeep(params)
      // 转换为数字
      searchObj.deliveredButNotReceivedFlag = searchObj.deliveredButNotReceivedFlag ? 1 : 0;
      searchObj.toBeDeliveredFlag = searchObj.toBeDeliveredFlag ? 1 : 0;
      searchObj.returnedFlag = searchObj.returnedFlag ? 1 : 0;
      if (this.organizationList?.length > 0) {
        searchObj.supplyOrganizationCodeList = this.organizationList.map(org => org.realValue); // 供应组织，后端用来判断权限
      }
      this.$refs.dataTable.searchParams = searchObj
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        returnedFlag: false,
        toBeDeliveredFlag: false,
        deliveredButNotReceivedFlag: false,
        supplyWipEntityName: undefined,
        orderNo: undefined,
        orderType: undefined,
        callDocNumber: undefined,
        workCode: undefined,
        itemCode: undefined,
        demandDate: undefined,
        startDemandDate: undefined,
        endDemandDate: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
